import { Edit3, Maximize2, Languages, RefreshCw, Crop as CropIcon } from 'lucide-react';

// Backend request limit guard
export const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024; // 10MB

export type Tab = 'Editing' | 'Cropping' | 'Translating' | 'Reformat';
export type VideoTab = 'Editing' | 'Extending';
export type EditorMode = 'picture' | 'video';

export const ALLOWED_TABS: ReadonlyArray<Tab> = ['Editing', 'Translating', 'Reformat', 'Cropping'];

export interface LandingPageProps {
  db: any; // Firestore instance
  uid: string; // User ID
  hasAccessToBulkTreatments: boolean;
  hasAccessToAiChat: boolean;
}

export interface ImageCategory {
  value: string;
  label: string;
}

export const tabIcons: Record<Tab, typeof Edit3> = {
  Editing: Edit3,
  Translating: Languages,
  Reformat: RefreshCw,
  Cropping: CropIcon,
};

export const videoTabIcons = {
  Editing: Edit3,
  Extending: Maximize2
};

// Image categories for reference photos
export const IMAGE_CATEGORIES: ImageCategory[] = [
  { value: 'reference', label: 'Reference' },
  { value: 'style', label: 'Style' },
  { value: 'product', label: 'Product' },
  { value: 'background', label: 'Background' },
  { value: 'character', label: 'Character' },
  { value: 'texture', label: 'Texture' },
  { value: 'template', label: 'Template' },
];
